export default "__VITE_ASSET__WRpId9MGVBUhIwNouPzelQ__"